import { render, staticRenderFns } from "./Placepozniej.vue?vue&type=template&id=82fbb014&scoped=true&"
import script from "./Placepozniej.vue?vue&type=script&lang=js&"
export * from "./Placepozniej.vue?vue&type=script&lang=js&"
import style0 from "./Placepozniej.vue?vue&type=style&index=0&id=82fbb014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fbb014",
  null
  
)

export default component.exports